<template>
    <div class="container">
        <div class="row">
            <heading>{{ $t('terminals.menuName') }}
            </heading>
        </div>
        <div class="row">
            <settingMenu></settingMenu>
            <div class="card col-10">
                <div class="card-body">
                    <LGTInput
                        :label="$t('terminals.fields.name')"
                        v-model="terminal.name"
                        error-key="name"
                        :errors="errors"
                        required
                    ></LGTInput>
                    <div class="btn btn-primary float-right" @click="store">{{ $t('core.actions.save') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import SettingMenu from '@/Components/SettingMenu'
import LGTInput from '@/components/LGTInput.vue'

export default {
    name: 'TerminalsCreadit',
    components: { LGTInput, SettingMenu },
    data: () => {
        return {
            errors: {},
            terminal: lgt.terminal || {
                name: ''
            },
        }
    },
    methods: {
        store() {
            if(this.terminal.id) {
                this.update()
            } else {
                this.create()
            }
        },
        create() {
            axios.post('/settings/terminal', this.terminal)
                .then(() => {
                    window.location.href = '/settings/terminal?success'
                })
                .catch(error => {
                    this.errors = error.response.data.errors
                })
        },
        update() {
            axios.post(`/settings/terminal/${this.terminal.id}`, this.terminal)
                .then(() => {
                    window.location.href = '/settings/terminal?success'
                })
                .catch(error => {
                    this.errors = error.response.data.errors
                })
        }
    }
}
</script>
